export function useStaticAsset() {
    function asset(path: string) {
        const base = import.meta.env.VITE_ASSET_URL
            ? import.meta.env.VITE_ASSET_URL
            : "";

        return base + path;
    }

    return {
        asset,
    };
}
